module.exports = "mutation saveInternalNote($internalNote:InternalNoteInput!){saveInternalNote(internalNote:$internalNote)}"